export default {"src":"/_next/static/media/new.f2633136.gif","height":40,"width":66};